import { render } from "./TicketForm.vue?vue&type=template&id=8fa27c58&ts=true"
import script from "./TicketForm.vue?vue&type=script&lang=ts"
export * from "./TicketForm.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__